import React from "react";
import GuestRegisterPage from "./views/GuestRegisterPage";
import { GuestRegisterContextProvider } from "./GuestRegisterView";
import Constants from "../../constants/contentFile.json";

const GuestRegisterView = () => {
  return (
    <GuestRegisterContextProvider>
      <GuestRegisterPage textContents={Constants.guestRegister} />
    </GuestRegisterContextProvider>
  );
};

export default GuestRegisterView;
